<div class="content">
  <div id="background"></div>
  <div class="info">
    <h1>J. Eduardo Castillo</h1>
    <ngx-typed-js [strings]="['Backend Developer', 'Frontend Developer', 'FullStack Developer^5000']" [typeSpeed]="65"
      [backSpeed]="45" [loop]="true">
      <h2><span class="typing"></span></h2>
    </ngx-typed-js>
  </div>
</div>
